// PLUGINS IMPORTS //
import React, { useState } from 'react'
import styled from 'styled-components/macro'

// COMPONENTS IMPORTS //
import HeaderSelector, { VarType } from './HeaderSelector/HeaderSelector'

import Projects from './Variables/Projects'
import Exposition from './Variables/Exposition'

import ScreenHeader from 'Content/Screens/GeneralScreens/PortfolioScreens/PortfolioScreen/Header/Header'
import Footer from 'Content/Shared/Layout/Footer/Footer'
import { memoComparison } from 'Content/Shared/Helpers/Functions/Functions'

// EXTRA IMPORTS //
import { GlobalStyles, iPhoneResolution } from 'Content/Shared/Styles/Theme'

/////////////////////////////////////////////////////////////////////////////

type PropsType = {}

const PortfolioScreen: React.FC<PropsType> = () => {
  const [selectedVar, setSelectedVar] = useState<VarType>('Exposition')

  return (
    <>
      <Wrapper>
        <ScreenHeader
          title={'Portfolio'}
          subtitle={
            'I had an opportunity to work with a number of clients from different industries and I am proud of taking part in their projects. Below I presented some of my recent projects:'
          }
        />
        <HeaderSelector
          selectedVar={selectedVar}
          setSelectedVar={setSelectedVar}
        />
        {selectedVar === 'Exposition' ? (
          <Exposition />
        ) : selectedVar === 'Projects' ? (
          <Projects />
        ) : null}
      </Wrapper>
      <Footer />
    </>
  )
}

/////////////////////////////////////////////////////////////////////////////

const MARGIN = '90px'
const Wrapper = styled.div`
  margin-right: ${MARGIN};
  margin-left: ${MARGIN};
  margin-bottom: 130px;
  margin-top: ${GlobalStyles.insets.pageTop}px;

  @media (max-width: ${iPhoneResolution}px) {
    margin-top: ${GlobalStyles.insets.pageTopMobile}px;
  }
`

export default React.memo(PortfolioScreen, memoComparison)
